module.exports = __webpack_public_path__ + "assets/img/media_32.875a8559.png";